import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import Calendar from "../../calendar/Calendar";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import MenuTable from "../../helpers/MenuTable";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import CalendarShow from "./CalendarYearEShow";
import InputTime from "../../helpers/InputTime";

function CalendarYearEShow(props)
{   

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [filterParam, setFilterParam] = useState({   

        id: props.row.id,

        d_imie_nazwisko:  '',
        r_imie_nazwisko:  '', 
        p_grupa_id: '_x_',
        zrealizowane:  '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });

   

    const [row, setRowX] = useState({
       
        id: props.row.id,
        cel_dnia: props.row.cel_dnia,
        data_wyslania_powiadomienia: props.row.data_wyslania_powiadomienia,
        dzien: props.row.dzien,
        godzina_wydarzenia: props.row.godzina_wydarzenia,
        forma_aktywnosci: props.row.forma_aktywnosci,
        grupy: props.row.grupy,
        przypomnij_dzien_przed: props.row.przypomnij_dzien_przed,
        temat_dnia: props.row.temat_dnia,
        uwagi_dodatkowe: props.row.uwagi_dodatkowe,
        wymagane: props.row.wymagane,
        p_grupa_id: props.p_grupa_id,
        edycja: props.row.edycja,
        

    });
    var tmpRow = row;

  
    var show_zapisz = false;

    if(props.row.id>0) show_zapisz=true;
    if(row.edycja==false) show_zapisz=false;


    const goDelete = (e) => {

        var id = e.target.getAttribute("id");
     
        props.mainView.setProgress(-2);
  
          var req = {
              id: id
          }
  
          fetch( Config.url + '/rest_v1_news,kalendarz_del', {
              method: 'POST', 
              body: JSON.stringify(req), 
              headers: {
                  'Content-Type': 'application/json',                    
                  'X-Api-Key': props.userData.apiKey,
                  '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                  '_p_dziecko_id_': props.userData.p_dziecko_id,
                  '_sec_key_': Config.genXKey() ,
              }
           })
           .then(res => res.json() )
           .then(res => {             
                      
                      props.mainView.setProgress(-1);
  
                      if(res._sys_ == undefined)
                      {
                          props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                      }else
                      if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                      {
                          props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                      }else
                      if(res.status != undefined && res.status == "OK")
                      {
                          //props.mainView.showDialog( "Sukces",  "Wpis został usunięty", "ok" , null);                        
                          props.onBack();
                      }else
                      {
                          props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                      }
                     
           } )
           .catch(err => {   
                      props.mainView.setProgress(-1);       
                      props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
           });
          
  
     }  


    const valChecker = (fields) => {

        var allValid = true;


        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    

    
    const saveData = () => {


        if(!valChecker(row))
           {
               props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
               return;
           }
     
      
     
                 props.mainView.setProgress(-2);     
     
                 fetch( Config.url + '/rest_v1_news,kalendarz_zapisz', {
                    method: 'POST', 
                    body: JSON.stringify(row), 
                    headers: {
                       'Content-Type': 'application/json',                    
                       'X-Api-Key': props.userData.apiKey,
                       '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                       '_p_dziecko_id_': props.userData.p_dziecko_id,
                       '_sec_key_': Config.genXKey() ,
                    }
                 })
                 .then(res => res.json() )
                 .then(res => { 
     
                             props.mainView.setProgress(-1);        
                             if(res._sys_ == undefined)
                             {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                             }else
                             if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                             {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                             }else    
                             {
                                  if(res.status != undefined && res.status == "OK")
                                   {
                                       props.mainView.showDialog( "Sukces",  "Pozycja została dodana", "ok" , null);                                     
                                       props.onBack();
                                   }else
                                   {
                                       props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                   }
                                
                             }
                 } )
                 .catch(err => {          
                             props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                             props.mainView.setProgress(-1);
                 });
                       
     
       }
    
    const valChangeListenerForm = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
  
        setRowX( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct } );      
        props.mainView.writeFilter(filedName, val);
     }
  
  
    const goNextNew = () => {
         
        //setTab(null);    
    }

  
    var tn = [
        { v: 0, title: 'Nie' }, 
        { v: 1, title: 'Tak, dzień wcześniej (rano) ' }, 
     ];
  
     var tnX = [
        { v: 0, title: 'Nie' }, 
        { v: 1, title: 'Tak ' }, 
     ];

    return (

            <div className="view_content">


                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Edycja wydarzenia
 
                            </div>
                                             
                            <Fragment>

<form className="eForm bg_center">

<div className="filter_controll">   
    <label>Grupa: </label>                             
        <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={row.p_grupa_id}   valChange={valChangeListenerForm} goNext={goNextNew} name="p_grupa_id" placeholder={"Grupa: "}   />
    </div> 

    { row.id<0 && 
        <div className="form_control">
        <div className="fieldName">Zapisać informacje dla <b>wszystich grup</b>?</div>
        <InputCombo items={tnX}   userData={props.userData} value={row.all} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="all" placeholder={":"} className=' w300 ' req='0' firstUp="0" />
        </div>
    }

<div className="form_control">
        <div className="fieldName">Godzina</div>
        <InputTime   userData={props.userData} value={row.godzina_wydarzenia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="godzina_wydarzenia" placeholder={"Godzina:"} className='  ' req='0' firstUp="0" />
    </div>   

      <div className="form_control">
            <div className="fieldName">Tytuł* (np. wyjście na spacer)</div>
            <InputText   userData={props.userData} value={row.temat_dnia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="temat_dnia" placeholder={"Tytuł:"} className=' w300 ' req='1' firstUp="0" />
      </div>

      <div className="form_control">
            <div className="fieldName">Forma aktywności</div>
            <InputTextArea   userData={props.userData} value={row.forma_aktywnosci} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="forma_aktywnosci" placeholder={"Forma aktywności:"} className=' w300 ' req='0' firstUp="0" />
      </div>

      <div className="form_control">
            <div className="fieldName">Cel dnia</div>
            <InputTextArea   userData={props.userData} value={row.cel_dnia} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="cel_dnia" placeholder={"Forma aktywności:"} className=' w300 ' req='0' firstUp="0" />
      </div>


      <div className="form_control">
            <div className="fieldName">Wymagane (ciepłe ubranie, buty na przebranie, ...)</div>
            <InputTextArea   userData={props.userData} value={row.wymagane} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="wymagane" placeholder={"Wymagane:"} className=' w300 ' req='0' firstUp="0" />
      </div>

      <div className="form_control">
            <div className="fieldName">Przypomnienie dla rodziców</div>
            <InputCombo items={tn}   userData={props.userData} value={row.przypomnij_dzien_przed} err={errTab}  valChange={valChangeListenerForm} goNext={goNextNew} name="przypomnij_dzien_przed" placeholder={":"} className=' w300 ' req='0' firstUp="0" />
      </div>

    

      <div className="form_split"></div>

      <div className="form_btn">
                                { show_zapisz && 
                                
                                    <div>
                                        <div className="btn" onClick={saveData}> zapisz </div>
                                        <div className="btn btn_del" onClick={goDelete} id={row.id}> usuń </div>
                                    </div>
                                }
                                <div className="btn btn_back" onClick={props.onBack}    > wróć</div>
                            </div>

</form>

</Fragment> 


                        </div>
                    </form>


            </div>
    )

}


export default CalendarYearEShow;


